import React from "react";
import { Box, Button } from "@mui/material";
import { motion } from "framer-motion";
import { ArrowRight, Building } from "lucide-react";
import CompanyCard from "bundles/Candidate/components/CompanyCard";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const TrustedCompaniesSection = ({
  trustedCompanies = [],
  companiesCount = 0,
}) => {
  const i18nLocale = useSelector((state) => state.i18nLocale);

  return (
    <Box
      component="section"
      sx={{
        py: { xs: "32px", md: "48px" },
        px: { xs: "16px", sm: "24px", lg: "32px" },
        bgcolor: "hsl(0, 0%, 100%)",
      }}
    >
      <Box sx={{ maxWidth: "1152px", mx: "auto" }}>
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          sx={{ textAlign: "center", mb: "48px" }}
        >
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              px: "16px",
              py: "6px",
              borderRadius: "9999px",
              bgcolor: "hsla(145, 63%, 42%, 0.1)",
              border: "1px solid hsla(145, 63%, 42%, 0.2)",
              color: "hsl(145, 63%, 42%)",
              fontSize: "0.75rem",
              fontFamily: "Segoe UI Bold, system-ui, sans-serif",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              mb: "16px",
            }}
          >
            <Building size={14} />
            <FormattedMessage id="landing_recruiter.trusted_companies.badge" />
          </Box>
          <Box
            component="h2"
            sx={{
              fontSize: { xs: "1.875rem", md: "2.25rem" },
              fontFamily: "Segoe UI Black, system-ui, sans-serif",
              color: "hsl(220, 25%, 12%)",
              letterSpacing: "-0.025em",
              mb: "16px",
              mt: 0,
            }}
          >
            <Box
              component="span"
              sx={{ color: "hsl(145, 63%, 42%)" }}
            >
              {companiesCount}
            </Box>{" "}
            <FormattedMessage id="landing_recruiter.trusted_companies.title_suffix" />
          </Box>
          <Box
            component="p"
            sx={{
              color: "hsl(220, 10%, 46%)",
              fontSize: "1.125rem",
              maxWidth: "672px",
              mx: "auto",
              fontFamily: "Segoe UI Regular, system-ui, sans-serif",
              textAlign: "center",
            }}
          >
            <FormattedMessage id="landing_recruiter.trusted_companies.subtitle" />
          </Box>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              lg: "repeat(4, 1fr)",
            },
            gap: "16px",
          }}
        >
          {trustedCompanies.map((company, i) => (
            <CompanyCard
              key={company.id}
              company={company}
              index={i}
              onClick={() => {
                window.location.href = `/${i18nLocale}/candidate/company/${company.id}?redirectTo=recruiters`;
              }}
            />
          ))}
        </Box>

        <Box sx={{ mt: "40px", textAlign: "center" }}>
          <Button
            component="a"
            href={`/${i18nLocale}/companies`}
            sx={{
              bgcolor: "hsl(153 68% 25%)",
              color: "white",
              fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
              fontWeight: 700,
              fontSize: "0.875rem",
              px: "1.5rem",
              py: "0.875rem",
              borderRadius: "0.75rem",
              textTransform: "none",
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              textDecoration: "none",
              "&:hover": {
                bgcolor: "hsl(153 68% 25% / 0.9)",
                textDecoration: "none",
              },
            }}
          >
            <FormattedMessage id="landing_recruiter.trusted_companies.cta" />
            <ArrowRight size={14} className="arrow-icon" />
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default TrustedCompaniesSection;
